module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/communication/clipboard-check-8de4254efc172db989f777336b448961.svg";